import React from 'react';

export default function EmptyState({ icon = '✨', title, msg, action }) {
  return (
    <div className="card" style={{ textAlign: 'center', padding: '30px 18px' }}>
      <div style={{ fontSize: 42, marginBottom: 8 }}>{icon}</div>
      {title && <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 6 }}>{title}</div>}
      {msg && <div className="text-dim" style={{ fontSize: 13, marginBottom: 14 }}>{msg}</div>}
      {action}
    </div>
  );
}
